import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, Container, Typography } from '@material-ui/core'

import PageWrapper from 'wrappers/PageWrapper/PageWrapper'
import SharedTabs from 'components/SharedTabs/SharedTabs'
import AttentionBanner from 'components/AttentionBanner/AttentionBanner'
import AlertListCard from 'cards/AlertListCard/AlertListCard'
import FeedbackSnackbar from 'shared/components/FeedbackSnackbar/FeedbackSnackbar'
import Button from 'components/Button/Button'
import AlertsAPI from 'api/AlertsAPI'
import RouteMap from 'assets/RouteMap.js'
import { useStyles } from './MyAlertsIndex_style'
import { isEmpty } from 'lodash'
import DeleteAlertModal from 'modals/DeleteAlertModal/DeleteAlertModal'

const ALERT_TYPE_CREATED_BY_USER = 'created_by_user'

const MyAlertsIndex = (props) => {
    const classes = useStyles()
    const { user, alerts } = props
    const [alertsByUser, setAlertsByUser] = useState([])
    const [specialAlerts, setSpecialAlerts] = useState()
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [alertIdToDelete, setAlertIdToDelete] = useState()
    const [feedback, setFeedback] = useState({ open: false, message: null, severity: null })
    const closeFeedback = () => setFeedback({ ...feedback, open: false })

    useEffect(() => {
        const [byUser, special] = alerts.reduce(
            ([byUsers, notbyUsers], item) => {
                return item.alert_type === ALERT_TYPE_CREATED_BY_USER
                    ? [[...byUsers, item], notbyUsers]
                    : [byUsers, [...notbyUsers, item]]
            },
            [[], []]
        )
        setAlertsByUser(byUser)
        setSpecialAlerts(special)
    }, [alerts])

    const closeModal = () => {
        setOpenDeleteModal(false)
        setAlertIdToDelete(null)
    }

    const openModalForConfirmation = (alert) => {
        setOpenDeleteModal(true)
        setAlertIdToDelete(alert.id)
    }

    const handleAlertDelete = () => {
        const remainingAlerts = alertsByUser.filter(alert => alert.id !== alertIdToDelete)
        setAlertsByUser(remainingAlerts)
        AlertsAPI.DeleteAlert({
            id: alertIdToDelete
        }).then(() => {
            setFeedback({
                open: true,
                message: <FormattedMessage id='my_alerts_index.alert_delete_success' />,
                severity: 'success'
            })
            closeModal()
        })
    }

    return (
        <PageWrapper user={user} disableFooterLists>
            <SharedTabs user={user} currentTab={window.location.pathname.replace(/^\/(fr|en|nl)\//g, '')} />
            <AttentionBanner user={user} />
            <FeedbackSnackbar
                open={feedback.open}
                message={feedback.message}
                severity={feedback.severity}
                closeFeedback={closeFeedback}
            />
            <DeleteAlertModal
                openDeleteModal={openDeleteModal}
                closeModal={closeModal}
                handleAlertDelete={handleAlertDelete}
            />
            <Container maxWidth='lg'>
                <Box className={classes.alertCreation}>
                    <Button variant='cta-primary' size='small' href={RouteMap.Page('create-your-job-alert')}>
                        <FormattedMessage id={'job_alert.sticky_button'} />
                    </Button>
                </Box>
                <Box className={classes.alertsContainer}>
                    {isEmpty(specialAlerts)
                        ? null
                        : <Box className={classes.specialAlertsContainer}>
                            <Typography variant='h1' component='h2' className={classes.title}>
                                <FormattedMessage id={'my_alerts_index.special_alerts.title'} />
                            </Typography>
                            {specialAlerts.map(alert =>
                                <Box className={classes.alertCard} key={alert.id}>
                                    <AlertListCard alert={alert} typeSpecial />
                                </Box>
                            )}
                        </Box>
                    }
                    <Typography variant='h1' component='h2' className={classes.title}>
                        <FormattedMessage id={'my_alerts_index.created_by_user_alerts.title'} />
                    </Typography>
                    {isEmpty(alertsByUser)
                        ? <Box my={8} className={classes.noResultsContainer}>
                            <Typography align='center'>
                                <FormattedMessage id='list_container.no_alerts' />
                            </Typography>
                        </Box>
                        : alertsByUser.map(alert =>
                            <Box className={classes.alertCard} key={alert.id}>
                                <AlertListCard alert={alert} remove={openModalForConfirmation} />
                            </Box>
                        )
                    }
                </Box>
            </Container>
        </PageWrapper>
    )
}

export default MyAlertsIndex
